const rankingItems = [
  {
    rank: 1,
    title: '咒术狂潮',
    tag: '日漫·奇幻',
    score: '9.7',
    hot: '本周热度第一',
    desc: '咒术师与诅咒之王的宿命对决，炫酷战斗场面与深刻角色塑造。',
  },
  {
    rank: 2,
    title: '重生之都市修仙',
    tag: '国漫·热血',
    score: '9.5',
    hot: '新话更新',
    desc: '一代仙尊重生都市，修法术战强敌，弥补所有遗憾。',
  },
  {
    rank: 3,
    title: '社长大人是恶魔',
    tag: '韩漫·恋爱',
    score: '9.3',
    hot: '人气飙升',
    desc: '冷酷社长与新人职员的办公室恋情，让人心跳加速。',
  },
  {
    rank: 4,
    title: '武林至尊',
    tag: '国漫·武侠',
    score: '9.4',
    hot: '稳定连载',
    desc: '少年从无名小卒成长为武林至尊，热血江湖恩怨情仇。',
  },
  {
    rank: 5,
    title: '穿越异世界成为药王',
    tag: '国漫·奇幻',
    score: '9.1',
    hot: '口碑佳作',
    desc: '现代药剂师穿越异世界，成为大陆最强药王扬名天下。',
  },
  {
    rank: 6,
    title: '甜蜜陷阱',
    tag: '恋爱·校园',
    score: '9.2',
    hot: '新番推荐',
    desc: '青梅竹马多年后重逢，甜蜜又虐心的校园恋爱故事。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            基于真实阅读数据的漫画排行榜，热门漫画一网打尽
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-4 md:gap-6 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div
                className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 font-heading font-bold text-lg md:text-xl ${
                  item.rank <= 3
                    ? 'bg-accent-500 text-white'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>

              <div className="flex flex-col items-end gap-1 flex-shrink-0">
                <div className="flex items-center gap-1">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                  <span className="text-sm md:text-base font-heading font-bold text-foreground-900">
                    {item.score}
                  </span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#cards"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 text-primary-600 font-medium rounded-full hover:bg-primary-50 transition-colors cursor-pointer text-sm whitespace-nowrap"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}